
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.4991 10.8H12.5009C10.457 10.8 8.8 12.457 8.8 14.5009C8.8 16.5449 10.457 18.2019 12.5009 18.2019H17.4991C19.543 18.2019 21.2 16.5449 21.2 14.5009C21.2 12.457 19.543 10.8 17.4991 10.8ZM12.5009 9C9.46285 9 7 11.4628 7 14.5009C7 17.539 9.46285 20.0019 12.5009 20.0019H17.4991C20.5372 20.0019 23 17.539 23 14.5009C23 11.4628 20.5372 9 17.4991 9H12.5009Z","fill":"#16171F"}}),_c('rect',{attrs:{"x":"7","y":"9.00006","width":"16","height":"11.0019","rx":"5.50093","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.4991 5.79908H6.50093C4.45696 5.79908 2.8 7.45605 2.8 9.50001C2.8 11.544 4.45696 13.2009 6.50093 13.2009H11.4991C13.543 13.2009 15.2 11.544 15.2 9.50001C15.2 7.45605 13.543 5.79908 11.4991 5.79908ZM6.50093 3.99908C3.46285 3.99908 1 6.46193 1 9.50001C1 12.5381 3.46285 15.0009 6.50093 15.0009H11.4991C14.5372 15.0009 17 12.5381 17 9.50001C17 6.46193 14.5372 3.99908 11.4991 3.99908H6.50093Z","fill":"#16171F"}})])
          )
        }
      }
    